export const RECENTLY_ACCESSED_APPS = [
    {
        post_id: 921,
        app_group: "HR",
        app_name: "iSuggest",
        app_code: "ISUGGEST",
        app_url:
            "https://apps.powerapps.com/play/7bd223e1-16fc-4cb8-9167-332e6e9c8c14?tenantId=311b3378-8e8a-4b5e-a33f-e80a3d8ba60a&amp%3bsource=portal&amp%3bscreenColor=rgba%280%2c%2063%2c%20114%2c%201%29",
        domesticinternational: "All",
        country_applicable: "All",
        bu_applicable: "All",
        du_applicable: "All",
        grade_applicable: "All",
        remarks: "",
    },
    {
        post_id: 920,
        app_group: "HR",
        app_name: "ROAR",
        app_code: "ROAR",
        app_url: "https://roar.vantagecircle.com/",
        domesticinternational: "All",
        country_applicable: "All",
        bu_applicable: "All",
        du_applicable: "All",
        grade_applicable: "All",
        remarks: "",
    },
    {
        post_id: 918,
        app_group: "HR",
        app_name: "SSC",
        app_code: "SSC",
        app_url: "https://ssc.larsentoubro.com/",
        domesticinternational: "All",
        country_applicable: "All",
        bu_applicable: "All",
        du_applicable: "All",
        grade_applicable: "All",
        remarks: "",
    },
    {
        post_id: 919,
        app_group: "HR",
        app_name: "Attendance",
        app_code: "ATTENDANCE",
        app_url: "https://myts.ltts.com/",
        domesticinternational: "All",
        country_applicable: "All",
        bu_applicable: "All",
        du_applicable: "All",
        grade_applicable: "All",
        remarks: "",
    },
];
export const REMINDER_DATA = [
    {
        notification: "New Intranet Survey",
        notificationTime: "6:00 pm",
        notificationType: "calendar",
    },
    {
        notification: "ITR form submission",
        notificationTime: "14th may",
        notificationType: "calendar",
    },
    {
        notification: "Call your manager for leaves",
        notificationTime: "",
        notificationType: "announcement",
    },
    {
        notification: "New intranet review internal",
        notificationTime: "6:00 pm",
        notificationType: "announcement",
    },
    {
        notification: "Project KT",
        notificationTime: "6:00 pm",
        notificationType: "announcement",
    },
    {
        notification: "Project KT",
        notificationTime: "6:00 pm",
        notificationType: "announcement",
    },
    {
        notification: "Project KT",
        notificationTime: "6:00 pm",
        notificationType: "announcement",
    },
    {
        notification: "Project KT",
        notificationTime: "6:00 pm",
        notificationType: "announcement",
    },
    {
        notification: "Project KT",
        notificationTime: "6:00 pm",
        notificationType: "announcement",
    },
    {
        notification: "Project KT",
        notificationTime: "6:00 pm",
        notificationType: "announcement",
    },
];

export const DYNAMIC_STACK_DATA = {
    status: 200,
    data: {
        dynamicStackItems: [
            {
                categoryType: "Recently Accessed",
                items: [
                    {
                        title: "Kaleidoscope",
                        label: "Finance",
                        icon: "http://example.com/icons/reminder.png",
                        details: {
                            message: "Submit your monthly expense reports.",
                            time: "2024-06-30T23:59:00Z",
                        },
                        createdAt: "2024-07-02T23:59:00Z",
                    },
                    {
                        title: "Synergy",
                        label: "Finance",
                        icon: "http://example.com/icons/reminder.png",
                        details: {
                            message: "Submit your monthly expense reports.",
                            time: "2024-06-30T23:59:00Z",
                        },
                        createdAt: "2024-07-02T23:59:00Z",
                    },
                    {
                        title: "Forex",
                        label: "Finance",
                        icon: "http://example.com/icons/reminder.png",
                        details: {
                            message: "Submit your monthly expense reports.",
                            time: "2024-06-30T23:59:00Z",
                        },
                        createdAt: "2024-07-02T23:59:00Z",
                    },
                    {
                        title: "Pearl",
                        label: "Q&P",
                        icon: "http://example.com/icons/reminder.png",
                        details: {
                            message: "Submit your monthly expense reports.",
                            time: "2024-06-30T23:59:00Z",
                        },
                        createdAt: "2024-07-02T23:59:00Z",
                    },
                ],
            },

            {
                categoryType: "Announcement",
                items: [
                    {
                        title: "Company-wide Holiday 1",
                        label: "Holiday",
                        icon: "http://example.com/icons/announcement.png",
                        details: {
                            image: "http://example.com/images/holiday.jpg",
                            link: "http://intranet.example.com/holiday-announcement",
                            postedBy: "HR Department",
                            deadline: "2024-07-03T23:59:00Z",
                        },
                        createdAt: "2024-07-02T23:59:00Z",
                    },
                    {
                        title: "Company-wide Holiday 2",
                        label: "Holiday",
                        icon: "http://example.com/icons/announcement.png",
                        details: {
                            image: "http://example.com/images/holiday.jpg",
                            link: "http://intranet.example.com/holiday-announcement",
                            postedBy: "HR Department",
                            deadline: "2024-07-03T23:59:00Z",
                        },
                        createdAt: "2024-07-02T23:59:00Z",
                    },
                ],
            },

            {
                categoryType: "My Day",
                items: [],
            },
            
            {
                categoryType: "CEO's Desk",
                items: [
                    {
                        title: "Showing headline",
                        label: "Headlines",
                        image: "http://example.com/icons/recommendation.png",
                        details: {
                            message:
                                "Your visa is expiring soon. Please renew before June 1st.",
                            actionURL: "http://intranet.example.com/visa-renewal",
                        },
                        createdAt: "2024-07-02T23:59:00Z",
                    },
                ],
            },
            {
                categoryType: "reminders",
                items: [],
            },
        ],
    },
    message: "Dynamic stack retrieved successfully",
    noOfRecords: 4,
};

export const CALENDAR_EVENTS = [
    {
        "id": "AAMkADcyZWE0YmRkLTU3NzItNGNkYS04MzJmLThmNDM3MTJkNDJiZgBGAAAAAADSSf39VQHwS7zLxbpluHjtBwCY8rA6eHsgQIQkwUdnSO4bAAAAAAENAACY8rA6eHsgQIQkwUdnSO4bAAFVfEoVAAA=",
        "subject": "Access Issue - DL Quality Dashboard - Reg",
        "start": {
            "dateTime": "2024-08-21T05:00:00.0000000",
            "timeZone": "UTC"
        },
        "end": {
            "dateTime": "2024-08-21T05:30:00.0000000",
            "timeZone": "UTC"
        },
        "onlineMeeting": {
            "joinUrl": "https://teams.microsoft.com/l/meetup-join/19%3ameeting_ZDlmMTJmMDItMTg0NC00MjcxLThjYTYtYTQ5MmZjMjc2YTEz%40thread.v2/0?context=%7b%22Tid%22%3a%22311b3378-8e8a-4b5e-a33f-e80a3d8ba60a%22%2c%22Oid%22%3a%2201235526-1cb1-4c97-9dcc-31ae1b0e7545%22%7d"
        }
    },
    {
        "id": "AAMkADcyZWE0YmRkLTU3NzItNGNkYS04MzJmLThmNDM3MTJkNDJiZgBGAAAAAADSSf39VQHwS7zLxbpluHjtBwCY8rA6eHsgQIQkwUdnSO4bAAAAAAENAACY8rA6eHsgQIQkwUdnSO4bAAFVfEoWAAA=",
        "subject": "LTTS - Calendar & Request for approvals Verification",
        "start": {
            "dateTime": "2024-08-21T05:45:00.0000000",
            "timeZone": "UTC"
        },
        "end": {
            "dateTime": "2024-08-21T06:15:00.0000000",
            "timeZone": "UTC"
        },
        "onlineMeeting": null
    },

    {
        "id": "AAMkADcyZWE0YmRkLTU3NzItNGNkYS04MzJmLThmNDM3MTJkNDJiZgBGAAAAAADSSf39VQHwS7zLxbpluHjtBwCY8rA6eHsgQIQkwUdnSO4bAAAAAAENAACY8rA6eHsgQIQkwUdnSO4bAAFUxUDtAAA=",
        "subject": "Predictive analytics on Quality Dashboard",
        "start": {
            "dateTime": "2024-08-20T11:30:00.0000000",
            "timeZone": "UTC"
        },
        "end": {
            "dateTime": "2024-08-20T12:00:00.0000000",
            "timeZone": "UTC"
        },
        "onlineMeeting": {
            "joinUrl": "https://teams.microsoft.com/l/meetup-join/19%3ameeting_NDk0M2VkMjUtMzM2OC00NjdjLWJjNWUtY2U2ZTYyMjE1NjE4%40thread.v2/0?context=%7b%22Tid%22%3a%22311b3378-8e8a-4b5e-a33f-e80a3d8ba60a%22%2c%22Oid%22%3a%22f2e91c19-5766-42d3-9067-55b0e66732b7%22%7d"
        }
    },
    {
        "id": "AAMkADcyZWE0YmRkLTU3NzItNGNkYS04MzJmLThmNDM3MTJkNDJiZgBGAAAAAADSSf39VQHwS7zLxbpluHjtBwCY8rA6eHsgQIQkwUdnSO4bAAAAAAENAACY8rA6eHsgQIQkwUdnSO4bAAFT1R_dAAA=",
        "subject": "LTTS - Feedback discussion",
        "start": {
            "dateTime": "2024-08-19T10:00:00.0000000",
            "timeZone": "UTC"
        },
        "end": {
            "dateTime": "2024-08-19T10:30:00.0000000",
            "timeZone": "UTC"
        },
        "onlineMeeting": null
    },
    {
        "id": "AAMkADcyZWE0YmRkLTU3NzItNGNkYS04MzJmLThmNDM3MTJkNDJiZgBGAAAAAADSSf39VQHwS7zLxbpluHjtBwCY8rA6eHsgQIQkwUdnSO4bAAAAAAENAACY8rA6eHsgQIQkwUdnSO4bAAFSCt3-AAA=",
        "subject": "Chennai ITS - Daily Progress App - Discussion",
        "start": {
            "dateTime": "2024-08-16T09:00:00.0000000",
            "timeZone": "UTC"
        },
        "end": {
            "dateTime": "2024-08-16T09:30:00.0000000",
            "timeZone": "UTC"
        },
        "onlineMeeting": {
            "joinUrl": "https://teams.microsoft.com/l/meetup-join/19%3ameeting_YjU5OWY5ZWYtNjk2NC00Mjg4LWIzMDYtNDdiZjAxOTI0Mjkz%40thread.v2/0?context=%7b%22Tid%22%3a%22311b3378-8e8a-4b5e-a33f-e80a3d8ba60a%22%2c%22Oid%22%3a%2281dd23c3-a105-4f12-a96f-130736ac81e7%22%7d"
        }
    },
    {
        "id": "AAMkADcyZWE0YmRkLTU3NzItNGNkYS04MzJmLThmNDM3MTJkNDJiZgBGAAAAAADSSf39VQHwS7zLxbpluHjtBwCY8rA6eHsgQIQkwUdnSO4bAAAAAAENAACY8rA6eHsgQIQkwUdnSO4bAAFSCt3_AAA=",
        "subject": "Ecdms And Qms Hosting ",
        "start": {
            "dateTime": "2024-08-16T10:00:00.0000000",
            "timeZone": "UTC"
        },
        "end": {
            "dateTime": "2024-08-16T10:30:00.0000000",
            "timeZone": "UTC"
        },
        "onlineMeeting": {
            "joinUrl": "https://teams.microsoft.com/l/meetup-join/19%3ameeting_N2JjNTRjMzItZjM2NC00M2ZhLWE4ODktYzk4YjNkMGJhNGY4%40thread.v2/0?context=%7b%22Tid%22%3a%22311b3378-8e8a-4b5e-a33f-e80a3d8ba60a%22%2c%22Oid%22%3a%2201235526-1cb1-4c97-9dcc-31ae1b0e7545%22%7d"
        }
    },
    {
        "id": "AAMkADcyZWE0YmRkLTU3NzItNGNkYS04MzJmLThmNDM3MTJkNDJiZgBGAAAAAADSSf39VQHwS7zLxbpluHjtBwCY8rA6eHsgQIQkwUdnSO4bAAAAAAENAACY8rA6eHsgQIQkwUdnSO4bAAFSCt39AAA=",
        "subject": "Ltts - Data queries",
        "start": {
            "dateTime": "2024-08-16T06:30:00.0000000",
            "timeZone": "UTC"
        },
        "end": {
            "dateTime": "2024-08-16T07:00:00.0000000",
            "timeZone": "UTC"
        },
        "onlineMeeting": null
    },
    {
        "id": "AAMkADcyZWE0YmRkLTU3NzItNGNkYS04MzJmLThmNDM3MTJkNDJiZgBGAAAAAADSSf39VQHwS7zLxbpluHjtBwCY8rA6eHsgQIQkwUdnSO4bAAAAAAENAACY8rA6eHsgQIQkwUdnSO4bAAFQ7v0vAAA=",
        "subject": "LTTS - BE Discussions",
        "start": {
            "dateTime": "2024-08-14T12:15:00.0000000",
            "timeZone": "UTC"
        },
        "end": {
            "dateTime": "2024-08-14T12:45:00.0000000",
            "timeZone": "UTC"
        },
        "onlineMeeting": null
    },
    {
        "id": "AAMkADcyZWE0YmRkLTU3NzItNGNkYS04MzJmLThmNDM3MTJkNDJiZgBGAAAAAADSSf39VQHwS7zLxbpluHjtBwCY8rA6eHsgQIQkwUdnSO4bAAAAAAENAACY8rA6eHsgQIQkwUdnSO4bAAFQ7v0uAAA=",
        "subject": "ECDMS & QMS Hosting -Reg",
        "start": {
            "dateTime": "2024-08-14T11:30:00.0000000",
            "timeZone": "UTC"
        },
        "end": {
            "dateTime": "2024-08-14T12:00:00.0000000",
            "timeZone": "UTC"
        },
        "onlineMeeting": {
            "joinUrl": "https://teams.microsoft.com/l/meetup-join/19%3ameeting_OGIyNGZjYjAtZWU1My00ZGIxLWFkNTUtMWZmYWU3ZWJhMGU0%40thread.v2/0?context=%7b%22Tid%22%3a%22311b3378-8e8a-4b5e-a33f-e80a3d8ba60a%22%2c%22Oid%22%3a%2201235526-1cb1-4c97-9dcc-31ae1b0e7545%22%7d"
        }
    },
    {
        "id": "AAMkADcyZWE0YmRkLTU3NzItNGNkYS04MzJmLThmNDM3MTJkNDJiZgBGAAAAAADSSf39VQHwS7zLxbpluHjtBwCY8rA6eHsgQIQkwUdnSO4bAAAAAAENAACY8rA6eHsgQIQkwUdnSO4bAAFQ7v0tAAA=",
        "subject": "LTTS - CMS Workflow demo",
        "start": {
            "dateTime": "2024-08-14T05:30:00.0000000",
            "timeZone": "UTC"
        },
        "end": {
            "dateTime": "2024-08-14T06:15:00.0000000",
            "timeZone": "UTC"
        },
        "onlineMeeting": null
    }
]
